// @flow

import { createContext } from 'react';
import { type Device } from './types';

export const DeviceContext = createContext<Device>('mobile');
